<form #basicForm="ngForm">
    <button 
        data-test="upload-button" 
        type="submit" 
        class="btn btn-border-radius btn-secondary"  
        (click)="openFileDialog()" 
        translate>
        Upload csv file
    </button>
    <input 
        type="file" 
        id="new_bulk_csv" 
        name="csvFile"
        accept=".csv" 
        (change)="newBulkFile($event)" 
        style="visibility:hidden;position:absolute; display: none"
        aria-label="Upload CSV file">
</form>
